import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject, Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { KonvasComponent } from "../../component/konvas/konvas.component";
import { DOCUMENT, NgForOf, NgIf } from "@angular/common";
import { faDownload, faShareNodes } from "@fortawesome/free-solid-svg-icons";
import { Carousel, CarouselItem, CarouselOptions } from "flowbite";
import Bowser from "bowser";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import mime from "mime";
import { CommonComponent } from "../../common/common-component";
import { ConfigService } from "../../common/service/config.service";
import { interval, merge, mergeMap, Subject, Subscription, take, takeUntil, tap, timer } from "rxjs";
import { environment } from "../../../environments/environment";
import { NotificationService } from "../../common/service/notification.service";
import { ProgressComponent } from "../../component/progress/progress.component";
import { ContentBlockComponent } from "../../component/content-block/content-block.component";
import { TrackerService } from "../../common/service/tracker.service";
import { DefaultImageDirective } from "../../common/directive/default-image.directive";

// @ts-ignore
// import TouchEmulator from "../../../assets/js/touch-emulator.js"

@Component({
  selector: 'section#result',
  standalone: true,
  imports: [
    FaIconComponent,
    KonvasComponent,
    NgForOf,
    NgIf,
    ProgressComponent,
    RouterLink,
    ContentBlockComponent,
    DefaultImageDirective
  ],
  templateUrl: './result.component.html',
})
export class ResultComponent extends CommonComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('carousel') carouselContainer: ElementRef | undefined;
  @ViewChildren('item') items!: QueryList<ElementRef>;
  @ViewChildren('indicator') indicators!: QueryList<ElementRef>;

  public sharingAvailable: boolean = true;
  public fullscreenEnabled: boolean = false;
  public isMobile: boolean = false;
  public disableDownload: boolean = false;
  public boothMode = false;

  public jobId: any;
  public job: any;
  public qr: any;


  protected readonly faDownload = faDownload;
  protected readonly faShareNodes = faShareNodes;

  private carousel: Carousel | undefined;
  private asset: { id: string, url: string, assets: Array<any> } | undefined;
  private browser: Bowser.Parser.Parser;
  private subscription: Subscription | undefined;
  private wsSubscription: Subscription | undefined;
  private trigger: Subject<any> = new Subject<any>();
  private completed: Subject<any> = new Subject();
  private viewport: any;

  private timeout: any;
  public defaultImageUrl: string = '/assets/images/expired.png';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private httpClient: HttpClient,
    @Inject('Window') private window: Window,
    @Inject(DOCUMENT) private document: Document,
    @Inject('Storage') protected storage: Storage,
    private configService: ConfigService,
    private notificationService: NotificationService,
    private tracker: TrackerService,
    private el: ElementRef
  ) {
    super();
    this.browser = Bowser.getParser(this.window.navigator.userAgent);
    this.sharingAvailable = !! window.navigator.share && (this.browser.getOSName(true) !== 'windows');
    this.isMobile = this.browser.getPlatformType(true) === 'mobile';
    this.fullscreenEnabled = this.document.fullscreenEnabled && ! this.isMobile;

    // console.log(this.browser.getOSName(true), 'this.document.fullscreenEnabled', this.document.fullscreenEnabled, 'this.isMobile', this.isMobile, 'this.fullscreenEnabled', this.fullscreenEnabled);

    if (this.browser.getOSName(true) === 'ios') {
      this.disableDownload = true;
    }

    this.boothMode = this.storage.getItem('forceBoothMode') === 'true';
  }

  ngOnInit(): void {

    if( ! this.boothMode) {

      this.tracker.conversion();

      this.viewport = this.document.querySelector("meta[name=viewport]");
      if (this.viewport) {
        this.viewport.setAttribute('content', 'user-scalable=yes, width=device-width, initial-scale=1, maximum-scale=12');
      }


      this.subscription = this.configService.config$.pipe(
        tap(config => this.config = config),
        mergeMap(() => this.route.params),
        tap(params => this.jobId = params['jobId']),
        mergeMap(() => this.route.queryParams),
        tap(p => this.qr = p['qr']),
        tap(this.registerQRCodeScan.bind(this)),
        tap(() => console.log('registered QR code scan')),
        tap(() => this.trigger.next(true)),
        mergeMap(() => merge(timer(10), interval(15000))),
        mergeMap(() => this.httpClient.get<any>(environment.api_v2_url + '/job/' + this.jobId)),
        // tap(() => console.log('polled job status')),
        tap(this.processJobPayload.bind(this)),
        // tap(() => console.log('processed job status')),
        takeUntil(this.completed),
        // tap(() => console.log('takeUntil not completed')),
      ).subscribe({
        complete: () => {
          this.httpClient.get<any>(environment.api_v2_url + '/job/' + this.jobId).subscribe(this.processJobPayload.bind(this));

          if(this.wsSubscription) {
            this.wsSubscription.unsubscribe();
          }
        }
      });

      this.wsSubscription = this.trigger.asObservable().pipe(
        take(1),
        mergeMap(() => this.notificationService.connect(this.jobId).asObservable())
      ).subscribe(message => {
        this.processJobPayload(message, true);
      })

    } else {
      this.subscription = this.configService.config$.pipe(
        tap(config => this.config = config),
        mergeMap(() => this.route.params),
        tap(params => this.jobId = params['jobId'])
      ).subscribe();

      this.timeout = setTimeout(() => {
        return this.router.navigate([ '../../home' ], { relativeTo: this.route }).then();
      }, 90 * 1000);
    }

  }

  ngAfterViewInit(): void {

    if(this.carouselContainer && this.items && this.items.length > 0) {
      this.buildCarousel();
      // TouchEmulator();
    }

    let touchstartX = 0
    let touchstartY = 0
    let touchendX = 0
    let touchendY = 0


    this.el.nativeElement.addEventListener('touchstart', (event: any) => {
      touchstartX = event.changedTouches[0].screenX;
      touchstartY = event.changedTouches[0].screenY;
    });

    this.el.nativeElement.addEventListener('touchend', (event: any) => {
      // console.log('touchend', event.changedTouches);
      touchendX = event.changedTouches[0].screenX;
      touchendY = event.changedTouches[0].screenY;
      if(event.changedTouches.length < 2 && Math.abs(touchstartX - touchendX) > (Math.abs(touchstartY - touchendY) * 2)) {
        if (touchendX < touchstartX) {
          this.next();
        } else {
          this.prev();
        }
      }
    });
  }

  async share() {
    if(this.asset) {

      if(this.carousel) {
        this.carousel.pause();
      }

      this.tracker.register({
        action: 'share',
        asset: this.asset.id,
        job: this.jobId
      }).then(console.log).catch(console.error);

      const filename = this.asset.url.split('/').pop();

      fetch(this.asset.url).then(r => r.blob()).then(blob => {

        const files = [
          new File([blob], filename!, { type: mime.getType(filename!) || 'application/octet-stream' })
        ];

        this.window.navigator.share({ files: files }).then(() => {
          console.log('shared successfully');
        }).catch(console.error);

      });
    }

  }

  download() {
    // console.log('download', this.asset);
    if(this.asset) {
      if (this.carousel) {
        this.carousel.pause();
      }
      const filename = this.asset.url.split('/').pop() || 'image.jpg';
      this.httpClient
        .get(this.asset.url, { responseType: 'arraybuffer' })
        .subscribe(response => {
          this.downloadFile(response, filename);
        });

      this.tracker.register({
        action: 'download',
        asset: this.asset.id,
        job: this.jobId
      }).then(console.log).catch(console.error);
    }
  }

  private downloadFile(response: ArrayBuffer, filename: string) {
    let blob = new Blob([ response ], { type: mime.getType(filename) || 'application/octet-stream' });
    let url = window.URL.createObjectURL(blob);
    let anchor = document.createElement("a");
    anchor.download = filename;
    anchor.href = url;
    anchor.click();
  }

  prev() {
    if (this.carousel) {
      this.carousel.prev();
    }
  }

  next() {
    if (this.carousel) {
      this.carousel.next();
    }
  }

  private buildCarousel(): void {

    // don't build carousel if there is no container
    if( ! this.carouselContainer) return;

    const options: CarouselOptions = {
      defaultPosition: 0,
      interval: 3000,
      indicators: {
        activeClasses: 'indicator-active',
        inactiveClasses: 'indicator-inactive',
        items: this.indicators.map((item: ElementRef, index): CarouselItem => { return { el: item.nativeElement, position: index }})
      },
      onChange: (carousel) => {
        // console.log('new slider item has been shown', carousel._getActiveItem());
        const item = carousel._getActiveItem();
        if(item) {
          if(item.el.lastChild instanceof HTMLVideoElement) {
            item.el.lastChild.muted = true;
            item.el.lastChild.play();
          }
          this.asset = this.job.assets.filter((i: { assetType: string }) => i.assetType == 'output')[item.position];
        }
      },
    }

    this.carousel = new Carousel(
      this.carouselContainer!.nativeElement,
      this.items.map((item: ElementRef, index): CarouselItem => { return { el: item.nativeElement, position: index }}),
      options
    );
  }

  getQRCode() {
    return `https://api.qrserver.com/v1/create-qr-code/?size=600x600&data=${encodeURIComponent(window.location.toString() + '?qr=1')}`
  }

  private registerQRCodeScan() {
    if (this.qr) {
      this.tracker.register({
        action: 'qrcode_scanned',
        job: this.jobId
      }).then(console.log).catch(console.warn);
    }

    this.tracker.register({
      action: 'view_result',
      job: this.jobId
    }).then(console.log).catch(console.warn);

  }

  private processJobPayload(job: any, wst: boolean = false) {

    if(job) {

      this.job = job;

      if(job['status'] == 'completed') {
        this.completed.next(true);

        if (wst) {
          this.tracker.register({
            action: 'wst',
            job: this.jobId
          }).then(console.log).catch(console.warn);
        }

        if(job.assets && job.assets.length == 2) {
          for(let asset of job.assets) {
            if(asset.assetType == 'output') {
              this.asset = asset;
            }
          }
        }

        setTimeout(() => {
          this.buildCarousel();
        }, 500);

      }



    }
  }

  ngOnDestroy(): void {
    // console.log('destroying result component');
    if(this.subscription) {
      // console.log('unsubscribing from subscription');
      this.subscription.unsubscribe();
    }
    if(this.wsSubscription) {
      // console.log('unsubscribing from wsSubscription');
      this.wsSubscription.unsubscribe();
    }

    if(this.timeout) {
      // console.log('clearing timeout');
      clearTimeout(this.timeout);
    }

    if (this.viewport) {
      this.viewport.setAttribute('content', 'user-scalable=no, width=device-width, initial-scale=1, maximum-scale=1');
    }
  }

  hasMoreThanOneOutputAsset(job: {assets: Array<any>}) {
    if(job.assets?.filter((asset: {assetType: string}) => asset.assetType == 'output')?.length > 1) {
      return true;
    }
    else {
      this.asset = job.assets?.filter((asset: {assetType: string}) => asset.assetType == 'output')[0];
      return false
    }
  }

  fallback($event: any) {
    console.log('fallback', $event);
  }

  isValidJobStatus(status: string): boolean {
    return status !== 'completed' && status.toLowerCase().indexOf('error') === -1;
  }

  isError(status: string): boolean {
    // console.log('isError', status, status.toLowerCase().indexOf('error'));
    return status.toLowerCase().indexOf('error') !== -1;
  }
}
